export default __webpack_public_path__ + "static/media/gridViewMobile.700a39db.svg";